<div class="flex w-72 flex-col gap-4 p-4">
  <div class="flex justify-center">
    <img
      class="h-12"
      src="/assets/integrations/heidi-square.jpg"
      alt="Heidi Health"
    />
  </div>

  <p class="!m-0 text-center text-sm text-gray-700">
    AI notes are generated using Heidi, a third-party AI scribing service. Click
    to sign up or connect your Heidi account.
  </p>

  <div class="flex flex-col gap-2">
    <button mat-flat-button color="primary" (click)="connectAccount.emit()">
      Connect Account
    </button>
    <a target="_blank" mat-stroked-button [href]="heidiSignupUrl">
      <span>Learn More</span>
      <mat-icon>open_in_new</mat-icon>
    </a>
  </div>
</div>
